/**
 * @created on 2018/11/15
 * @author huangtiande
 **/
import { axios as $http } from 'cm'
import {
  getRunTime,
  GetRequest
} from '../../../public-resource/libs/utils/index'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'

import qs from 'qs'
import { Base64 } from 'js-base64'
import './style.scss'
import Bridge from '../../../frontend-lib/lib/Bridge'
import rewardImg from './img/reward-img.png'
import {
  // callWechatPay,
  directAliPay,
  directWechatPay
} from 'src/frontend-lib/lib/payUnit.js'

import monitor from '../../../frontend-lib/lib/monitor'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let STATIC_HOST = getRunTime('//static.xinli001.com')

let AppPayForm = `<form id="process-app-form" action="yixinli://process_payment?">
<input type="hidden" name="data" value="" />
</form>`
if (window.$platform.isYixinliApp && $('#process-app-form').length === 0) {
  $('body').append(AppPayForm)
}

let APIS = {
  isLogin: `${HOST}/ajax/get-user-header`,
  pay: `${HOST}/zhifu/reward-create-dingdan`, // 订单生成
  payStatus: `${HOST}/zhifu/reward-pay-callback`, // 查询是否支付成功
  login: `${HOST}/account/login`
}

let myBrige = new Bridge()
/**
 * @param {object}
 *   object.el  打赏点击DOM (建议只留一个CLASS类，避免犯错)
 *   object.APIS  请求接口
 *   object.changeNumDom 打赏完成改变的DOM（内容仅限数字） 若改参数没有则寻找点击触发的DOM下面的类rewardNum
 *   object.successCallPay  成功调用支付（获取支付订单）
 *   object.callbackFn  成功支付回调
 *   object.rewarType 打赏类型 默认qa.reward(问答打赏)
 *   object.token     当前登录token , 若该参数没有则去请求
 *   object.userId    当前登录ID , 若该参数没有则去请求
 *   object.jumpWXpay    若有此参数，则跳到微信独立支付页
 */
export default class Reward {
  constructor(options) {
    let UAobj = getPlatform()
    if (UAobj.isWechat && UAobj.isiPhone) {
      $('body').on('click', options.el, function() {
        window.toast('微信不支持苹果手机用户打赏', 2000)
      })
      return
    }

    this.payStatus = `<div class="payStatus"><div class="y-expert-p show" id="zf"><div class="bd">请根据你的付款情况点击以下按钮</div><div class="ft"><span id="dialog-confirm">已付款</span><span id="dialog-cancel">未付款</span></div></div></div>`

    this.loadingDiv = `<div class="loadingDiv"><div class="mint-indicator-wrapper" style="padding: 15px;"><span class="mint-indicator-spin"><div class="mint-spinner-snake" style="border-top-color: rgb(204, 204, 204); border-left-color: rgb(204, 204, 204); border-bottom-color: rgb(204, 204, 204); height: 32px; width: 32px;"></div></span> <span class="mint-indicator-text" style="display: none;"></span></div></div>`

    if ($('.loadingDiv').length === 0) {
      $('body').append(this.loadingDiv)
    }
    if ($('.payStatus').length === 0) {
      $('body').append(this.payStatus)
    }

    let rewardDom = `<div class="reward-popup-wrap">
    <div class="reward-popup-div">
        <div class="reward-popup-circle">
            <img src="${rewardImg}" alt="">
        </div>
        <div class="reward-popup-ct">
            <i class="yxl-font yxl-font-FM51delete close-reward"></i>
            <div class="reward-popup-ct-title">每一种付出，都值得被鼓励</div>
            <div class="reward-popup-ct-t">
                <ul>
                    <li class="active">1元</li>
                    <li>2元</li>
                    <li>5元</li>
                </ul>
            </div>
            <input type="number" class="number-input" placeholder="或输入其他金额数字，1～100元" max="100" />
            <div class="pay-div">
                <ul>
                    <li class="active">微信支付<span></span></li>
                    <li>支付宝<span></span></li>
                </ul>
            </div>
            <input type="button" class="pay-btn" value="去支付" />
            <div class="Agreement"><a href="https://m.xinli001.com/qa/reward/agreement">《壹心理打赏用户协议》</a></div>
            <div class="tips">打赏是什么？如何开通</div>
        </div>
    </div>
</div>`
    if ($('.reward-popup-wrap').length === 0) {
      $('body').append(rewardDom)
    }

    // 微信端处理
    if (UAobj.isWechat) {
      $('.pay-div ul li')
        .eq(1)
        .remove()
      $('.pay-div ul li')
        .eq(0)
        .css({ float: 'none', margin: '0 auto' })
    }
    this.ativePayType = null
    this.object_id = null
    this.dingdan_id = null
    this.userToken = options.token || ''
    this.IS_APP = window.$platform.isYixinliApp
    this.urlparams = GetRequest()
    this.clickElem = options.el
    this.callbackFn = options.callbackFn
    this.changeNumDom = options.changeNumDom || null
    this.user_id = options.userId || null
    this.jumpWXpay = options.jumpWXpay || null
    this.business = options.business || '问答'
    if (options.APIS) {
      APIS = { ...APIS, ...options.APIS }
    }
    this.payType = options.payType || 'qa.reward'
    if (window.localStorage.getItem('rewardObjId')) {
      this.object_id = window.localStorage.getItem('rewardObjId')
    }
    this.successCallPay = options.successCallPay || null
    if (!this.userToken && this.userToken !== '') this.testLogin()
    this.init()
  }
  init() {
    // 显示打赏页面
    let that = this
    if (this.IS_APP) {
      // APP打赏回调
      window.myBrige = new Bridge({
        disInitAppHook: true,
        methods: [
          {
            method: 'appBecomeActiveStatus',
            callback(obj) {
              if (that.ativePayType !== that.payType) {
                return false
              }
              if (obj.data.status === 'paySuccess') {
                window.localStorage.removeItem('reward_dingdan')
                $('.reward-popup-wrap').hide()
                if (that.callbackFn) {
                  that.callbackFn()
                }
                that.changeRewardNum()
                window.toast('打赏成功，感谢真诚和爱~', 2000, function() {
                  // window.toast('页面刷新中~');
                  // window.location.reload();
                })
                return
              } else if (obj.data.status === 'payFailure') {
                window.toast('支付失败')
                return
              } else if (obj.data.status === 'h5Disappear') {
                return false
              } else {
                var dingdan_id = window.localStorage.getItem('reward_dingdan')
                if (!dingdan_id) {
                  return
                }
                $('.loadingDiv').hide()
                $('.loadingDiv').show()
                $http
                  .post(
                    APIS.payStatus,
                    qs.stringify({
                      id: dingdan_id
                    })
                  )
                  .then(res => {
                    if (+res.data.code === 0) {
                      $('.loadingDiv').hide()
                      window.localStorage.removeItem('reward_dingdan')
                      $('.reward-popup-wrap').hide()
                      if (that.callbackFn) {
                        that.callbackFn()
                      }
                      that.changeRewardNum()
                      window.toast('打赏成功，感谢真诚和爱~', 2000, function() {
                        // window.toast('页面刷新中~');
                        // window.location.reload();
                      })
                    } else {
                      $('.loadingDiv').hide()
                      window.localStorage.removeItem('reward_dingdan')
                      window.toast('您没有完成打赏支付！')
                    }
                  })
                  .catch(err => {
                    console.log(err)
                    window.localStorage.removeItem('reward_dingdan')
                    $('.loadingDiv').hide()
                  })
              }
            }
          }
        ]
      })
    }

    if (this.urlparams.pay_callback) {
      if (window.sessionStorage.getItem('payType') !== that.payType) return
      this.dingdan_id = window.localStorage.getItem('reward_dingdan')
      if (this.dingdan_id) {
        $('.payStatus').show()
      }
    }
    $('body').on('click', this.clickElem, function() {
      that.ativePayType = that.payType
      if (!that.userToken) {
        window.toast('未登录，稍后为您跳转到登录页面', 3000)
        window.loginTimer = setTimeout(() => {
          let _href = that.IS_APP
            ? 'yixinli://open_user_login'
            : `${APIS.login}?next=${encodeURIComponent(window.location.href)}`
          window.location.href = _href
        }, 2000)
        return false
      }
      var login_user = $(this).attr('data-userid')

      that.object_id =
        that.payType === 'user.reward'
          ? login_user
          : $(this).attr('data-objectid')
      if (!window.baseInfo) {
        return
      }
      if (!login_user || !that.object_id) {
        window.toast('缺少打赏对象~~')
        return false
      }

      if (login_user == that.user_id) {
        window.toast('不能给自己打赏')
      } else {
        window.localStorage.setItem(
          'rewardObjId',
          $(this).attr('data-objectid')
        )
        $('.number-input').val('')
        $('.reward-popup-ct-t ul li').removeClass('active')
        $('.reward-popup-ct-t ul li')
          .eq(0)
          .addClass('active')
        $('.pay-div li').removeClass('active')
        $('.pay-div li')
          .eq(0)
          .addClass('active')
        $('.reward-popup-wrap').show()
      }
    })

    // 打赏金额三个选项切换
    $('.reward-popup-ct-t ul li').click(function(e) {
      $(this).addClass('active')
      $('.number-input').val('')
      $(this)
        .siblings()
        .removeClass('active')
    })

    // 打赏方式选择
    $('.pay-div ul li').click(function(e) {
      $(this).addClass('active')
      $(this)
        .siblings()
        .removeClass('active')
    })

    // 打赏金额校验
    $('.number-input').on('input', function(e) {
      if (parseInt($(this).val()) === 0) {
        $(this).val('')
      }
      if (
        $(this)
          .val()
          .indexOf('.') > -1 &&
        $(this)
          .val()
          .split('.').length >= 2
      ) {
        var newValue = parseFloat($('.number-input').val())
        $('.number-input').val('')
        $('.number-input').val(newValue)
      }
      $('.reward-popup-ct-t ul li').removeClass('active')
      // 如果输入非数字，则替换为''
      this.value = this.value.replace(/[^\d\.]/g, '')
      // 必须保证第一个为数字而不是.
      this.value = this.value.replace(/^\./g, '')
      // 保证只有出现一个.而没有多个.
      this.value = this.value.replace(/\.{2,}/g, '.')
      // 保证.只出现一次，而不能出现两次以上
      this.value = this.value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      // 只能输入两位小数
      this.value = this.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (reg.test($(this).val())) {
        if (parseInt($(this).val()) === 0) {
          $(this).val('')
        }
        let max = $(this)[0].max ? $(this)[0].max : 100
        if (parseFloat($(this).val()) >= max) {
          $(this).val($(this)[0].max)
        }
      }
    })
    $('.number-input').blur(function() {
      var newValue = parseFloat($('.number-input').val())
      $('.number-input').val('')
      $('.number-input').val(newValue)
    })

    // 支付
    $('.pay-btn').click(function(e) {
      if (that.ativePayType !== that.payType) {
        return false
      }
      var UA = getPlatform()
      if (!that.object_id) {
        window.toast('缺少打赏对象')
        return false
      }
      let params = {
        price: '', // 价格，1-100之间
        payway: '', // 支付方式，alipay | weixin
        object_id: that.object_id, // 回答id
        object_name: that.payType, // 打赏类型，默认传入qa.reward
        agreement: 'yes', // 协议勾线，默认传入yes，未勾选传入no
        open_form: 'yixinli_mobi', // 支付形式，yixinli_pc | yixinli_mobi | yixinli_app
        pay_succes_redirect: window.location.href
      }
      if (that.IS_APP) {
        params.open_form = 'yixinli_app'
      }
      if (!$('.reward-popup-ct-t li').hasClass('active')) {
        if (
          parseFloat($('.number-input').val()) <= 0 ||
          $('.number-input')
            .val()
            .trim() === ''
        ) {
          window.toast('请输入打赏金额')
          return false
        } else {
          params.price = $('.number-input').val()
        }
      } else {
        $('.reward-popup-ct-t li').each(function(index, e) {
          if ($(e).hasClass('active')) {
            params.price = parseInt($(e).html())
            return false
          }
        })
      }
      $('.pay-div li').each(function(index, e) {
        if ($(e).hasClass('active')) {
          let typeValue = index == 0 ? 'weixin' : 'alipay'
          params.payway = typeValue
          return false
        }
      })
      if (UA.isWechat && params.payway === 'weixin') {
        params.is_weixin = '1' // 是否微信端
        params.code = window.baseInfo.wxcode // 微信端支付需要传入
      }
      if (UA.isiPhone) {
        params._platform = 'ios'
      } else if (UA.isAndroid) {
        params._platform = 'android'
      }

      params.platform_source = UA.isYixinliApp
        ? 'APP'
        : UA.isWechat
        ? 'JSAPI'
        : 'MWEB'
      if (!UA.isYixinliApp && !UA.isWechat) {
        // platform_source参数继续调整
        if (window.$platform.isPc) {
          params.platform_source = params.payway === 'weixin' ? 'MWEB' : 'PAGE'
        } else {
          params.platform_source = params.payway === 'weixin' ? 'MWEB' : 'WAP'
        }

        if (that.urlparams.pay_callback == '1') {
          params.pay_succes_redirect = window.location.href
        } else if (
          Object.keys(that.urlparams).length === 0 &&
          !that.urlparams.pay_callback
        ) {
          params.pay_succes_redirect = window.location.href + '?pay_callback=1'
        } else if (
          Object.keys(that.urlparams).length > 0 &&
          !that.urlparams.pay_callback
        ) {
          params.pay_succes_redirect = window.location.href + '&pay_callback=1'
        }
      }

      if (that.jumpWXpay && UA.isWechat && params.payway === 'weixin') {
        let urlData = Base64.encode(JSON.stringify(params))
        window.location.href = `${HOST}/zhifu/order-pay-confirm?data=${urlData}&payname=yixinlitool`
        return
      }

      $('.loadingDiv').hide()
      $('.loadingDiv').show()
      $http
        .post(APIS.pay, qs.stringify(params))
        .then(res => res.data)
        .then(res => {
          $('.loadingDiv').hide()
          monitor.stat({
            logType: 'pay',
            title: `${that.business}-支付日志`,
            message: JSON.stringify(params),
            url: APIS.pay,
            code: res.code,
            payParameters: JSON.stringify(res),
            resultMessage: 'payApiResponse',
            userId: that.user_id,
            UA: navigator.userAgent
          })
          if (+res.code === 0) {
            window.sessionStorage.setItem('payType', that.ativePayType)
            if (that.successCallPay) {
              that.successCallPay()
            }
            that.dingdan_id = res.data.dingdan_id
            window.localStorage.setItem('reward_dingdan', that.dingdan_id)
            let payParameters = res.data.pay_action.body
            if (UA.isWechat && params.payway == 'weixin') {
              function onBridgeReady() {
                // var wxData = {
                //   appId: newParams.appId,
                //   timeStamp: String(newParams.timeStamp),
                //   nonceStr: newParams.nonceStr,
                //   package: newParams.package,
                //   signType: newParams.signType,
                //   paySign: newParams.paySign
                // }
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest',
                  payParameters,
                  function(res) {
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                      that.changeRewardNum()
                      $('.reward-popup-wrap').hide()
                      window.toast(
                        '打赏成功，感谢真诚和爱~',
                        1000,
                        function() {}
                      )
                    }
                    if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                      window.toast('取消支付')
                    } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                      window.toast('支付失败')
                    }

                    monitor.stat({
                      logType: 'pay',
                      title: `${that.business}-支付日志`,
                      message: JSON.stringify(params),
                      url: location.href,
                      code: res.err_msg,
                      payParameters: JSON.stringify(payParameters),
                      resultMessage: res.err_msg,
                      userId: that.user_id,
                      UA: navigator.userAgent
                    })
                  }
                )
              }
              if (typeof WeixinJSBridge === 'undefined') {
                if (document.addEventListener) {
                  document.addEventListener(
                    'WeixinJSBridgeReady',
                    onBridgeReady,
                    false
                  )
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
                }
              } else {
                onBridgeReady()
              }
            } else if (!UA.isYixinliApp && params.payway === 'weixin') {
              $('.payStatus').show()
              if (UA.isiPhone) {
                window.localStorage.setItem('rewardType', 'weixin')
              }
              directWechatPay(payParameters.mwebUrl, params.pay_succes_redirect)
            } else if (!UA.isYixinliApp && params.payway === 'alipay') {
              $('.payStatus').show()
              window.localStorage.setItem('rewardType', 'alipay')
              directAliPay(payParameters)
            } else if (UA.isYixinliApp) {
              // $('.payStatus').show();
              document
                .querySelector('#process-app-form input[name="data"]')
                .setAttribute('value', res.data.pay_action)
              document.querySelector('#process-app-form').submit()
            }
          } else {
            window.toast(res.message)
          }
        })
        .catch(err => {
          $('.loadingDiv').hide()
          window.toast(err)

          monitor.stat({
            logType: 'pay',
            title: `${that.business}-支付日志`,
            message: JSON.stringify(err),
            url: location.href,
            code: '',
            payParameters: JSON.stringify(params),
            resultMessage: '',
            userId: that.user_id,
            UA: navigator.userAgent
          })
        })
    })

    $('.tips').click(function(e) {
      e.stopPropagation()
      var Host = getRunTime('//static.xinli001.com')
      if (that.IS_APP) {
        myBrige.call('openWebView', {
          url:
            window.location.protocol +
            '//' +
            Host +
            '/msite/index.html#/open-reward',
          isCurrentPageOpen: 0
        })
      } else {
        window.location.href =
          window.location.protocol +
          '//' +
          Host +
          '/msite/index.html#/open-reward'
      }
    })
    $('#dialog-confirm').click(function() {
      if (window.sessionStorage.getItem('payType') !== that.payType) {
        return
      }
      if (!that.dingdan_id) {
        window.toast('请勿违规操作！')
        return false
      }
      $('.loadingDiv').hide()
      $('.loadingDiv').show()

      $http
        .post(
          APIS.payStatus,
          qs.stringify({
            id: that.dingdan_id
          })
        )
        .then(res => {
          $('.loadingDiv').hide()
          $('.payStatus').hide()
          that.ativePayType = null
          window.sessionStorage.removeItem('payType')
          window.localStorage.removeItem('reward_dingdan')
          if (+res.data.code === 0) {
            if (that.callbackFn) {
              that.callbackFn()
            }
            window.toast('打赏成功，感谢真诚和爱~', 2000)
            that.changeRewardNum()
            // window.location.reload();
          } else {
            window.toast('您没有完成打赏支付！')
          }
        })
        .catch(err => {
          that.ativePayType = null
          window.sessionStorage.removeItem('payType')
          window.localStorage.removeItem('reward_dingdan')
          $('.loadingDiv').hide()
        })
    })

    $('#dialog-cancel').click(function() {
      window.localStorage.removeItem('reward_dingdan')
      $('.payStatus').hide()
      that.ativePayType = null
      window.sessionStorage.removeItem('payType')
    })

    $('.reward-popup-wrap').click(function(e) {
      if ($(e.target).hasClass('reward-popup-wrap')) {
        $('.reward-popup-wrap').hide()
        that.object_id = null
        that.ativePayType = null
      }
    })

    $('.close-reward').click(function() {
      $('.reward-popup-wrap').hide()
      that.object_id = null
      that.ativePayType = null
    })
  }

  changeRewardNum() {
    if (window.localStorage.getItem('rewardType')) {
      window.localStorage.removeItem('rewardType')
      return false
    }
    if (this.changeNumDom) {
      this.changeNumDom.html($(this.changeNumDom).html() + 1)
    } else if (
      $(`[data-objectid=${this.object_id}]`).find('.rewardNum').length > 0
    ) {
      let newNum = $(`[data-objectid=${this.object_id}]`)
        .find('.rewardNum')
        .html()
      newNum = +newNum + 1
      $(`[data-objectid=${this.object_id}]`)
        .find('.rewardNum')
        .html(newNum)
      window.localStorage.removeItem('rewardObjId')
    }
  }

  // 验证登录
  testLogin() {
    let that = this
    window.getTokenFn = function(obj) {
      let newObj = JSON.parse(obj)
      if (newObj.token) {
        that.userToken = newObj.token
      } else {
        window.location.href = 'yixinli://open_user_login'
      }
    }
    if (this.IS_APP) {
      myBrige.call('getToken', { callbackName: 'getTokenFn' })
    }
    $http
      .get(APIS.isLogin, {
        params: {}
      })
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0) {
          if (res.data.user && res.data.user.token) {
            if (!this.userToken) {
              this.userToken = res.data.user.token
            }
            this.user_id = res.data.user.id
          }
        }
      })
      .catch(err => {
        window.toast(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/reward/index.js